import React from "react";
import { uniqueId } from "lodash";
import { IllustrationProps } from ".";

const uid = uniqueId();

export default ({ colors }: IllustrationProps) => (
  <svg width="100%" height="100%" viewBox="0 0 440 120">
    <defs>
      <circle id={"disc" + uid} cx={18} cy={18} r={18} />

      <g id={"line" + uid} fill={colors.content.tertiary}>
        <mask id={"mask" + uid} fill="#FFF">
          <use xlinkHref={"#disc" + uid} />
        </mask>
        <use xlinkHref={"#disc" + uid} />
        <path
          d="M30.125 32.173L23.8 29.056a2.404 2.404 0 01-1.356-2.169v-2.473c.201-.255.388-.52.56-.796a12.551 12.551 0 001.916-3.914 1.89 1.89 0 001.356-1.846v-2.643a1.8 1.8 0 00-.644-1.44V9.929S26.428 4 18.423 4c-8.004 0-7.207 5.93-7.207 5.93v3.845a1.91 1.91 0 00-.644 1.44v2.643c.023.664.348 1.28.881 1.677a12.656 12.656 0 002.409 4.964v2.405a2.312 2.312 0 01-1.29 2.084l-5.85 3.202A5.37 5.37 0 004 36.832V39h29v-1.999a5.381 5.381 0 00-2.875-4.828z"
          fill={colors.content.primary}
          mask={`url(#mask${uid})`}
        />
        <rect x={52} y={14} width={92} height={10} rx={5} />
        <rect x={375} y={14} width={38} height={10} rx={5} />
        <rect x={310} y={14} width={40} height={10} rx={5} />
        <rect x={247} y={14} width={38} height={10} rx={5} />
      </g>
    </defs>

    <g fill={colors.content.secondary}>
      <path d="M8 25V13H6.672L3 15.454l.835.936c1.34-.941 2.094-1.475 2.258-1.6.164-.127.313-.247.446-.362-.05.635-.076 1.308-.076 2.02V25H8z" />
      <path d="M11 67v-1.246H3.957v-.065l2.997-2.533c1.336-1.122 2.248-2.05 2.735-2.783.487-.734.73-1.475.73-2.225 0-.96-.365-1.725-1.095-2.294-.73-.57-1.74-.854-3.025-.854-1.486 0-2.86.453-4.121 1.36l.824.914c.624-.426 1.191-.72 1.7-.882a5.299 5.299 0 011.615-.243c.787 0 1.402.185 1.845.554.444.37.665.87.665 1.501 0 .448-.087.866-.262 1.255a5.104 5.104 0 01-.787 1.197c-.35.41-1.074 1.095-2.172 2.055L2 65.843V67h9z" />
      <path d="M5.762 111c1.674 0 2.965-.3 3.874-.898.91-.599 1.364-1.455 1.364-2.567 0-.777-.266-1.405-.8-1.884-.532-.48-1.35-.777-2.454-.895v-.063c.903-.16 1.6-.477 2.093-.95.492-.474.738-1.084.738-1.829 0-.905-.37-1.617-1.11-2.136C8.727 99.26 7.69 99 6.354 99c-.815 0-1.59.108-2.327.323a7.028 7.028 0 00-1.952.89l.79.895c.684-.373 1.292-.628 1.825-.767a6.75 6.75 0 011.702-.207c.79 0 1.415.162 1.876.487.46.324.691.772.691 1.341 0 .713-.313 1.27-.94 1.673-.627.402-1.477.603-2.549.603H4.097v1.141h1.354c2.621 0 3.931.708 3.931 2.124 0 1.58-1.188 2.371-3.564 2.371-.602 0-1.24-.065-1.914-.195A9.625 9.625 0 012 109.108v1.261c.57.234 1.158.398 1.763.491.605.093 1.271.14 1.999.14z" />
    </g>

    <use xlinkHref={"#line" + uid} x={27} />
    <use xlinkHref={"#line" + uid} x={27} y={43} />
    <use xlinkHref={"#line" + uid} x={27} y={85} />
  </svg>
);
